import { SubSink } from 'subsink';
import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RxFormBuilder } from '@rxweb/reactive-form-validators';

import { LoginService } from '../../services/login.service';
import { NotifyAlertService } from '@monorepo/ui';
import { AuthService } from '@monorepo/ui/auth';

import { ForgotPassword } from '../../models/';
import { environment } from '../../../../../environments/environment';
import { LoginViewEnum } from '../login-view.enum';

@Component({
  selector: 'signgaze-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
  readonly subs = new SubSink();

  loginView: any = LoginViewEnum;
  forgotPasswordForm: FormGroup;
  URL: string = environment.resetPasswordURL;
  isSubmitted = false;

  constructor(
    private loginService: LoginService,
    private notifyAlertService: NotifyAlertService,
    private authService: AuthService,
    private rxFb: RxFormBuilder
  ) {
    this.createForgotPasswordForm();
  }

  private createForgotPasswordForm(): void {
    this.forgotPasswordForm = this.rxFb.formGroup(ForgotPassword);
  }

  public forgotPassword(): void {
    this.isSubmitted = true;
    const email = this.forgotPasswordForm.get('email').value;
    this.subs.sink = this.authService.resetPassword(email, this.URL).subscribe({
      next: (): void => {
        this.isSubmitted = false;
        this.notifyAlertService.success(
          'We have e-mailed your password reset link !'
        );
        this.changeLoginView(this.loginView.LOGIN);
      },
      error: (): void => {
        this.isSubmitted = false;
      },
    });
  }

  public changeLoginView(currentLoginView: LoginViewEnum): void {
    this.loginService.currentLoginView$.next(currentLoginView);
  }
}
